import { useSelector } from "react-redux";
import { selectCartesianConfiguration, selectCartesianCurrentStep } from "../../../Cartesian/store/slices/cartesian";
import { selectConfigurationType } from "../../store/slices/common";
import {
  selectIntegratedDrivesConfiguration,
  selectIntegratedDrivesCurrentStep
} from "../../../IntegratedDrives/store/slices/integrated_drives";
import { selectMc12Configuration, selectMc12CurrentStep } from "../../../Mc12/store/slices/mc12";
import { selectRetrofitConfiguration, selectRetrofitCurrentStep } from "../../../Retrofit/store/slices/retrofit";
import t from "../translation/translator";

export const CARTESIAN = "cartesian";
export const LOAD_PARAMETERS_FIELD = "lp";
export const FORCE_PARAMETERS_FIELD = "fp";
export const AXIS_ANGLE_FIELD = "axisAngle";
export const STROKE_LENGTH_FIELD = "strokeLength";
export const CARRIAGE_DISTANCE_FIELD = "carriageDistance";
export const FULL_SCREEN_FIELD = "fullscreen";

export function validateForceParamRow(input_title, input_fx, input_fy, input_fz, input_dx, input_dy, input_dz) {
  const title = input_title === undefined ? "" : input_title;
  const fx = input_fx === undefined ? "" : input_fx;
  const fy = input_fy === undefined ? "" : input_fy;
  const fz = input_fz === undefined ? "" : input_fz;
  const dx = input_dx === undefined ? "" : input_dx;
  const dy = input_dy === undefined ? "" : input_dy;
  const dz = input_dz === undefined ? "" : input_dz;

  const isAnyoneNotEmpty = fx !== "" || fy !== "" || fz !== "" || dx !== "" || dy !== "" || dz !== "";
  const isAnyoneEmpty = fx === "" || fy === "" || fz === "" || dx === "" || dy === "" || dz === "";
  const isAllEmpty = fx === "" && fy === "" && fz === "" && dx === "" && dy === "" && dz === "";
  const isAllForcesZero = Number(fx) === 0 && Number(fy) === 0 && Number(fz) === 0;
  const isAllForcesNegative =
    Number(fx) < 0 || Number(fy) < 0 || Number(fz) < 0 || Number(dx) < 0 || Number(dy) < 0 || Number(dz) < 0;
  return title === "" || isAllEmpty || isAllForcesZero || (isAnyoneNotEmpty && isAnyoneEmpty) || isAllForcesNegative;
}

export function getAxisCombinations() {
  return [
    {
      name: "PAS42B ",
      description: {
        name: "Linear Axis PAS42B",
        profileSize: "60 x 60 mm",
        driveType: "Toothed belt",
        feed: "155 mm/U",
        repeatability: "0,005mm"
      },
      items: [
        {
          id: 1,
          guideType: "Ball guide",
          carriageType: "Carriage 1",
          feedConstant: "155",
          mechanicalDriveElement: "Toothed belt",
          repeatability: "0,05",
          profileSize: "60 x 60",
          carriageLength: "206",
          axisLength: "1232.5",
          axisWeight: "9.30",
          guideSystem: "30 000km - 15",
          carriageWeight: "0,896",
          driveTorqueAxisUtilization: "60",
          speedAxisUtilization: "20",
          serviceLifeGuideSystem: "90",
          serviceLifeGuideSystemYears: "0,0",
          axisPerformance: "Too Big",
          priceIndicator: "€€",
          technicalComment: "Stroke too long"
        },
        {
          id: 2,
          guideType: "Roller guide",
          carriageType: "Carriage 2",
          feedConstant: "160",
          mechanicalDriveElement: "Toothed belt",
          repeatability: "0,06",
          profileSize: "70 x 70",
          carriageLength: "210",
          axisLength: "1300",
          axisWeight: "10.00",
          guideSystem: "35 000km - 20",
          carriageWeight: "1.00",
          driveTorqueAxisUtilization: "65",
          speedAxisUtilization: "25",
          serviceLifeGuideSystem: "5",
          serviceLifeGuideSystemYears: "1,0",
          axisPerformance: "Perfect",
          priceIndicator: "€€€",
          technicalComment: "Good performance"
        },
        {
          id: 3,
          guideType: "Slide guide",
          carriageType: "Carriage 3",
          feedConstant: "170",
          mechanicalDriveElement: "Toothed belt",
          repeatability: "0,07",
          profileSize: "80 x 80",
          carriageLength: "220",
          axisLength: "1400",
          axisWeight: "11.00",
          guideSystem: "40 000km - 25",
          carriageWeight: "1.10",
          driveTorqueAxisUtilization: "70",
          speedAxisUtilization: "30",
          serviceLifeGuideSystem: "100",
          serviceLifeGuideSystemYears: "2,0",
          axisPerformance: "Perfect",
          priceIndicator: "€€€€",
          technicalComment: "Excellent performance"
        }
      ]
    },
    {
      name: "PAS43B",
      description: {
        name: "Linear Axis PAS42C",
        profileSize: "90 x 90 mm",
        driveType: "Toothed belt",
        feed: "180 mm/U",
        repeatability: "0,008mm"
      },
      items: [
        {
          id: 4,
          guideType: "Ball guide",
          carriageType: "Carriage 1",
          feedConstant: "180",
          mechanicalDriveElement: "Toothed belt",
          repeatability: "0,08",
          profileSize: "90 x 90",
          carriageLength: "230",
          axisLength: "1500",
          axisWeight: "12.00",
          guideSystem: "45 000km - 30",
          carriageWeight: "1.20",
          driveTorqueAxisUtilization: "75",
          speedAxisUtilization: "35",
          serviceLifeGuideSystem: "105",
          serviceLifeGuideSystemYears: "3,0",
          axisPerformance: "Perfect",
          priceIndicator: "€€€€€",
          technicalComment: "Superb performance"
        },
        {
          id: 5,
          guideType: "Roller guide",
          carriageType: "Carriage 2",
          feedConstant: "190",
          mechanicalDriveElement: "Toothed belt",
          repeatability: "0,09",
          profileSize: "100 x 100",
          carriageLength: "240",
          axisLength: "1600",
          axisWeight: "13.00",
          guideSystem: "50 000km - 35",
          carriageWeight: "1.30",
          driveTorqueAxisUtilization: "80",
          speedAxisUtilization: "40",
          serviceLifeGuideSystem: "110",
          serviceLifeGuideSystemYears: "4,0",
          axisPerformance: "Perfect",
          priceIndicator: "€€",
          technicalComment: "Superb performance"
        },
        {
          id: 6,
          guideType: "Roller guide",
          carriageType: "Carriage 2",
          feedConstant: "190",
          mechanicalDriveElement: "Toothed belt",
          repeatability: "0,09",
          profileSize: "100 x 100",
          carriageLength: "240",
          axisLength: "1600",
          axisWeight: "13.00",
          guideSystem: "50 000km - 35",
          carriageWeight: "1.30",
          driveTorqueAxisUtilization: "80",
          speedAxisUtilization: "40",
          serviceLifeGuideSystem: "110",
          serviceLifeGuideSystemYears: "4,0",
          axisPerformance: "Perfect",
          priceIndicator: "€€",
          technicalComment: "Superb performance"
        }
      ]
    }
  ];
}

export function removeFullscreenText(selectedField) {
  return selectedField?.includes(FULL_SCREEN_FIELD) ? selectedField?.split(`${FULL_SCREEN_FIELD}.`)[1] : selectedField;
}

export function getAnimation3DTitle(selectedField) {
  // const field = removeFullscreenText(selectedField);
  switch (selectedField) {
    case STROKE_LENGTH_FIELD:
      return t("cartesian.ui.mechanics.stroke_length");
    case AXIS_ANGLE_FIELD:
      return t("cartesian.ui.mechanics.axis_angle");
    case CARRIAGE_DISTANCE_FIELD:
      return t("cartesian.ui.mechanics.carriage_distance");
    case LOAD_PARAMETERS_FIELD:
      return t("cartesian.ui.mechanics.point_load");
    case FORCE_PARAMETERS_FIELD:
      return t("cartesian.ui.mechanics.point_force");
    default:
      return "";
  }
}

export function getCurrentConfiguration() {
  const configurationType = useSelector(selectConfigurationType);
  switch (configurationType) {
    case "CARTESIAN":
      return useSelector(selectCartesianConfiguration);
    case "MC12":
      return useSelector(selectMc12Configuration);
    case "INTEGRATED_DRIVES":
      return useSelector(selectIntegratedDrivesConfiguration);
    default:
      return useSelector(selectRetrofitConfiguration);
  }
}

export function getCurrentStep() {
  const configurationType = useSelector(selectConfigurationType);
  switch (configurationType) {
    case "CARTESIAN":
      return useSelector(selectCartesianCurrentStep);
    case "MC12":
      return useSelector(selectMc12CurrentStep);
    case "INTEGRATED_DRIVES":
      return useSelector(selectIntegratedDrivesCurrentStep);
    default:
      return useSelector(selectRetrofitCurrentStep);
  }
}

const Simplesteps = {
  START: {
    id: 1,
    label: t("start"),
    done: false,
    status: "IN_PROGRESS"
  },
  APPLICATION_SETTINGS: {
    id: 2,
    label: t("msizer.ui.stepper.app_settings"),
    done: false,
    status: "IN_PROGRESS"
  },
  SPECIFY_SELECT: {
    id: 3,
    label: t("msizer.ui.stepper.specify_select"),
    done: false,
    status: "IN_PROGRESS"
  },
  SPECIFY: {
    id: 3_1,
    label: t("msizer.ui.stepper.specify"),
    done: true,
    status: "IN_PROGRESS"
  },
  SELECT: {
    id: 3_2,
    label: t("msizer.ui.stepper.select"),
    done: false,
    status: "IN_PROGRESS"
  },
  SAVEANDSHARE: {
    id: 5,
    label: t("msizer.ui.stepper.save_and_share"),
    done: false,
    status: "FINISHED"
  }
};

export const Steps = {
  Simplesteps,
  KINEMATICS: {
    id: 6,
    label: t("cartesian.ui.stepper.kinematics"),
    done: false,
    status: "IN_PROGRESS"
  },
  MECHANICS: {
    id: 7,
    label: t("cartesian.ui.stepper.mechanics"),
    done: false,
    status: "IN_PROGRESS"
  },
  DYNAMICS: {
    id: 8,
    label: t("cartesian.ui.stepper.dynamics"),
    done: false,
    status: "IN_PROGRESS"
  },
  AXIS_SELECTION: {
    id: 9,
    label: t("cartesian.ui.stepper.axisselection"),
    done: false,
    status: "IN_PROGRESS"
  },
  AXIS_OPTIONS: {
    id: 10,
    label: t("cartesian.ui.stepper.axisoptions"),
    done: false,
    status: "IN_PROGRESS"
  },
  ACCESSORIES: {
    id: 11,
    label: t("cartesian.ui.stepper.accessories"),
    done: false,
    status: "IN_PROGRESS"
  },
  FINALIZE: {
    id: 12,
    label: t("cartesian.ui.stepper.finalize"),
    done: false,
    status: "IN_PROGRESS"
  }
};
